/*
 * @Author: zhouwei
 * @Date: 2019-11-18 15:31:23
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-05-29 11:53:16
 * @Desc: 表单提交数据列表
*/
<template>
  <div class="table-list">
    <div class="table-wrapper">
      <mk-table
        ref="multipleTable"
        class="table-list-c"
        height="100%"
        :data="formData"
        :show-overflow-tooltip="false"
        @selection-change="handleSelectionChange"
      >
        <mk-table-column
          type="selection"
          width="50"
        >
        </mk-table-column>
        <mk-table-column
          prop="avatarURL"
          label="头像"
          width="75"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.avatarURL"
              class="img"
            >
          </template>
        </mk-table-column>
        <mk-table-column
          prop="nickname"
          label="昵称"
        >
          <template slot-scope="scope">
            {{ scope.row.nickName }}
          </template>
        </mk-table-column>
        <mk-table-column
          v-for="(item,index) in titleList"
          :key="index"
          :prop="item.id"
          :label="item.name"
        ></mk-table-column>
        <mk-table-column
          prop="departeName"
          label="部门"
          fixed="right"
          label-class-name="fixed-header"
        >
        </mk-table-column>
        <mk-table-column
          prop="memberName"
          label="销售"
          fixed="right"
          label-class-name="fixed-header"
        >
        </mk-table-column>
      </mk-table>
    </div>
    <div class="table-info">
      <div class="table-info-screen">
        共筛选出{{ screen }}条
      </div>
      <div class="table-info-page">
        <mk-pagination
          class="page-btn"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="screen"
          :current-page="page"
          @current-change="changePage"
        >
        </mk-pagination>
        <!-- <div class="info">
          10条/页
        </div>
        <div class="exchange-into">
          跳至
        <input
          v-model="nowPage"
          type="number"
          @keyup.enter="updatePage"
        />
        页
      </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { BIZAPIS } from '@api'
import dayjs from 'dayjs'
export default {
  props: {
    member: {
      type: [Array, String],
      default () {
        return []
      }
    },
    memberList: {
      type: Array,
      default () {
        return []
      }
    },
    dept: {
      type: [Array, String],
      default () {
        return []
      }
    },
    departeList: {
      type: Array,
      default () {
        return []
      }
    },
    isAll: {
      type: Boolean,
      default: false
    },
    date: {
      type: [String, Array],
      default () {
        return []
      }
    }
  },
  data () {
    return {
      page: 1,
      nowPage: 1,
      screen: 0, // 共筛选出多少条
      titleList: [],
      formData: [
        // 表单数据
      ],
      deptArr: [] // 部门id数据集合
    }
  },
  computed: {
    startTime () {
      return dayjs(this.date[0]).format('YYYY-MM-DD HH:mm:ss')
    },
    endTime () {
      return dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
    }
  },
  created () {
    this.getTitleList(false)
  },
  methods: {
    initPage () {
      this.page = 1
      this.nowPage = 1
    },
    handleSelectionChange (arr) {
      // 获取选中项
      if (arr.length > 0) {
        this.$emit('select', arr)
      } else {
        this.$emit('cancel')
      }
    },
    clearSelect () {
      // 清空选择
      // this.$refs.multipleTable.$children[0].clearSelection()
      this.$refs.multipleTable.clearSelection()
    },
    updatePage () {
      let e = Number(this.nowPage)
      let pageNum = 0
      if (e <= 1) {
        pageNum = 1
      } else if (e >= Math.ceil(this.screen / 10)) {
        pageNum = Math.ceil(this.screen / 10)
      } else {
        pageNum = e
      }
      this.page = pageNum
      this.nowPage = pageNum
      this.getFormDataList(this.startTime, this.endTime, this.dept, this.member)
    },
    changePage (e) {
      this.page = e
      this.nowPage = e
      this.getFormDataList(this.startTime, this.endTime, this.dept, this.member)
    },
    async getFormDataList (startTime, endTime, dept, userIds, search) {
      let metas = {
        formId: this.$route.query.id,
        page: this.page,
        startTime: startTime,
        endTime: endTime,
        dept: dept,
        userIds: userIds
      }
      if (startTime === undefined || startTime === '') {
        delete metas['startTime']
      }
      if (endTime === undefined || endTime === '') {
        delete metas['endTime']
      }
      if (!dept || dept.length === 0) {
        delete metas['dept']
      }
      if (!userIds || userIds.length === 0) {
        delete metas['userIds']
      }
      const res = await BIZAPIS.FormDataApi.materialFormDataDetailPost(metas)
      if (res.success) {
        let data = res.data.data
        this.screen = res.data.total
        if (res.data.total === 0) {
          this.$emit('handle-show', false)
        } else {
          if (search === 'search') {
            this.$emit('handle-show', true)
          }
        }
        this.$emit('screen', this.screen)
        let arr = []
        data.forEach((item, index) => {
          let obj = {}
          for (let s in item.formData) {
            obj[s] = item.formData[s]
          }
          arr[index] = {
            ...item,
            ...obj,
            memberName: this.getMemberName(item.userId),
            departeName: item.deptIds
              ? this.getDeparteName(item.deptIds[0], this.departeList)
              : ''
          }
        })
        this.formData = arr
      }
    },
    async getTitleList (isAll) {
      const res = await BIZAPIS.FormMetaApi.materialFormMetaGet({
        formId: this.$route.query.id,
        isAll: isAll
      })
      let arr = []
      if (res.success) {
        if (res.data instanceof Array) {
          res.data.forEach((item, index) => {
            if (
              item.type === 'radio' ||
              item.type === 'select' ||
              item.type === 'input' ||
              item.type === 'textarea' ||
              item.type === 'address'
            ) {
              if (item.isDelete) {
                arr.push({
                  id: item._id,
                  name: item.config.title + '（已删）'
                })
              } else {
                arr.push({
                  id: item._id,
                  name: item.config.title
                })
              }
            }
          })
          arr.push({
            id: 'showTime',
            name: '提交时间'
          })
          this.titleList = arr
        }
      }
    },
    getMemberName (id) {
      let name = ''
      // 这里是不用forEach, 因为无法使用break
      if (this.memberList instanceof Array) {
        let i = 0
        let len = this.memberList.length
        let data = this.memberList
        for (i; i < len; i++) {
          if (data[i]._id === id) {
            name = data[i].name
            break
          }
        }
      }
      return name
    },
    getDeparteName (id, arr) {
      let newArr = arr
      this.getHandleArr(newArr)
      let name = ''
      // 这里是不用forEach, 因为无法使用break
      let i = 0
      let data = this.deptArr
      let len = data.length
      for (i; i < len; i++) {
        if (data[i]._id === id) {
          name = data[i].name
          break
        }
      }
      return name
    },
    getHandleArr (arr) {
      // 递归
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          this.deptArr.push({
            _id: item._id,
            name: item.name
          })
          if (item.children instanceof Array) {
            this.getHandleArr(item.children)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  .table-wrapper {
    height: 100%;
    overflow: auto;
  }

  .table-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;

    /deep/ .mk-pagination {
      margin-top: 0;
    }

    .table-info-screen {
      font-size: 13px;
      color: #6d7278;
    }

    .table-info-page {
      display: flex;

      .info {
        width: 80px;
        height: 24px;
        box-sizing: border-box;
        border-radius: 2px;
        font-size: 14px;
        color: #595959;
        text-indent: 8px;
        line-height: 24px;
      }

      .exchange-into {
        margin-left: 10px;
        font-size: 14px;
        line-height: 24px;
        color: #595959;

        input {
          width: 48px;
          height: 24px;
          box-sizing: border-box;
          text-indent: 8px;
          margin-right: 8px;
          border: 1px solid #8c8c8c;
          border-radius: 2px;
          color: #262626;
        }
      }
    }
  }

  // /deep/ .el-table__fixed-right::before {
  //   display: none;
  // }

  // /deep/ .fixed-header {
  //   padding: 12px 0;
  // }

  .img {
    display: block;
    width: 36px;
  }
}
</style>
